const memoryFallback = new Map();

const safeStorage = () => {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      const probe = "__pp_probe__";
      window.localStorage.setItem(probe, "1");
      window.localStorage.removeItem(probe);
      return window.localStorage;
    }
  } catch (e) {
    // Storage blocked (private mode, third-party iframe): fall back to memory.
  }
  return null;
};

export const makeGuestStore = (prefix = "") => {
  const storage = safeStorage();
  const key = (name) => `${prefix}${name}`;
  return {
    prefix,
    get(name) {
      try {
        if (storage) return storage.getItem(key(name));
      } catch (e) {
        // fall through
      }
      return memoryFallback.has(key(name)) ? memoryFallback.get(key(name)) : null;
    },
    set(name, value) {
      try {
        if (storage) {
          storage.setItem(key(name), value);
          return;
        }
      } catch (e) {
        // fall through
      }
      memoryFallback.set(key(name), value);
    },
    remove(name) {
      try {
        if (storage) storage.removeItem(key(name));
      } catch (e) {
        // ignore
      }
      memoryFallback.delete(key(name));
    },
  };
};

export const randomSessionId = () => {
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
};

export const getOrCreateWidgetSession = (store) => {
  const existing = store.get("guestSessionId");
  if (existing && existing.length >= 10) return existing;
  const fresh = randomSessionId();
  store.set("guestSessionId", fresh);
  return fresh;
};
